import { Button as AntButton, Checkbox, Collapse, message, Modal, Slider } from "antd";
import imgConfidencial from "assets/img/institucion-confidencial.png";
import placeholder_image from "assets/img/placeholder-image-2.jpg";
import Button from "components/Button";
import Editor from "components/editor";
import Loader from "components/loader";
import html2canvas from "html2canvas";
import { useEffect, useRef, useState } from "react";
import { useQuill } from "react-quilljs";
import LevelCircle from "views/admin/default/components/LevelCircle";
import { HttpGet, HttpPost } from "../../../../services/Http";
import './ModalGraphicResources.css';

const PUBLIC_URI = process.env.REACT_APP_PUBLIC_URI_IMAGES;


export default function ModalGraphicResources({ isModalOpen, setIsModalOpen, data, type = 'post', setType }) {

    const postRef = useRef();
    const storyRef = useRef();
    const feedRef = useRef();

    const inputRef1 = useRef();
    const inputRef2 = useRef();

    const [isLoading, setIsLoading] = useState(false);

    const [institucion, setInstitucion] = useState("");
    const [ubicacion, setUbicacion] = useState("");
    const [puesto, setPuesto] = useState("");
    const [requisitos, setRequisitos] = useState("");
    const [hasSetContent, setHasSetContent] = useState(false);
    const [confidencial, setConfidencial] = useState(false);

    const [imagen, setImagen] = useState("");
    const [imagen3, setImagen3] = useState("");
    const [imagen2, setImagen2] = useState("");
    const [imgSize, setImgSize] = useState("150");
    const [imgSize2, setImgSize2] = useState("150");
    const [isImage2Enabled, setIsImage2Enabled] = useState(false);
    const [isImage1Enabled, setIsImage1Enabled] = useState(true);
    const [isImage3Enabled, setIsImage3Enabled] = useState(false);

    const [scale, setScale] = useState(32);
    const [column, setColumn] = useState(false);

    const [ejeYImg1, setEjeYImg1] = useState(210);
    const [ejeYImg2, setEjeYImg2] = useState(294);

    const [ejeYImgDoble, setEjeYImgDoble] = useState(210);
    const [displayImgs, setDisplayImgs] = useState('block');
    const [displayDoble, setDisplayDoble] = useState('none');

    const [titleSize, setTitleSize] = useState(46);
    const [locationSize, setLocationSize] = useState(44);
    const [jobSize, setJobSize] = useState(54);
    const [nivel, setNivel] = useState(null)

    const theme = 'snow';
    const placeholder = 'Contenido de los requisitos';
    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link']
        ],
    };

    const { quillRef, quill } = useQuill({ theme, modules, placeholder });

    const moreThanOneImageactive = () => {

        let count = 0

        if (isImage1Enabled) count++
        if (isImage2Enabled) count++
        if (isImage3Enabled) count++

        return count > 1
    }

    const handleClose = () => {
        setIsModalOpen(false);
        setType(null);
    };

    const generateImageBlob = async (reference) => {
        // Validamos que la referencia y el elemento existan
        if (!reference || !reference.current) {
            // console.error("Referencia no vinculada al DOM", reference);
            return null;
        }

        const element = reference.current;

        try {
            const originalTransform = element.style.transform;
            element.style.transform = "scale(1)";

            const canvas = await html2canvas(element, {
                useCORS: true,
                allowTaint: true,
                scale: 2,
            });

            element.style.transform = originalTransform;

            return new Promise((resolve) => {
                canvas.toBlob((blob) => {
                    resolve(blob);
                }, "image/png");
            });
        } catch (err) {
            // console.error("Error en html2canvas:", err);
            return null;
        }
    };

    const handleAttachToPublication = async () => {
        try {
            setIsLoading(true);

            // 1. Validar que tengamos una referencia válida
            const activeRef = type === 'post' ? postRef : type === 'story' ? storyRef : type === 'feed' ? feedRef : null;

            if (!activeRef || !activeRef.current) {
                message.warning("No se encontró la referencia visual para generar la imagen.");
                return;
            }

            const imageBlob = await generateImageBlob(activeRef);
            if (!imageBlob) return;

            // 2. Preparar el FormData
            const formData = new FormData();
            formData.append("tipo", type);
            formData.append("archivo", imageBlob, `${type}_kit.png`);

            // 3. Llamada a HttpPost con el TRUCO para el Header
            // Pasamos "Content-Type": null para que el navegador lo gestione solo
            // O simplemente enviamos el FormData y ajustamos HttpPost
            const responseUpload = await HttpPost(
                `publicacion/${data?.id}/media-kits`,
                formData,
                true, // withToken
                { "Content-Type": undefined } // Esto es clave
            );

            if (responseUpload?.error) { // Validar si tu errorResponse devuelve algo así
                throw new Error(responseUpload.message);
            }

            message.success("Media kit adjuntado con éxito");
            handleClose();
        } catch (error) {
            // console.error("Error al adjuntar media kit:", error);
            message.error("Error al subir el archivo.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleDownload = async () => {
        try {
            setIsLoading(true);
            if (type === 'post') {
                if (postRef?.current) {
                    const originalWidth = postRef.current.offsetWidth;
                    const originalHeight = postRef.current.offsetHeight;

                    postRef.current.style.transform = "scale(1)";

                    const canvas = await html2canvas(postRef?.current, {
                        useCORS: true,
                        allowTaint: true,
                        // scale: window.devicePixelRatio, // Capturar en alta resolución
                        scale: 2,
                        width: originalWidth,
                        height: originalHeight,
                    });
                    const dataUrl = canvas.toDataURL("image/png", 1.0);
                    const link = document.createElement("a");
                    link.href = dataUrl;

                    const name = confidencial
                        ? `Confidencial-${ubicacion}.png`
                        : `Post_${data?.nombre.replace(/ /g, "_")}_${data?.cuenta?.nombre.replace(/ /g, "_")}.png`

                    link.download = name;
                    link.click();

                    postRef.current.style.transform = `scale(${scale / 100})`;
                }
            } else if (type === 'story') {
                if (storyRef?.current) {
                    const originalWidth = storyRef.current.offsetWidth;
                    const originalHeight = storyRef.current.offsetHeight;

                    storyRef.current.style.transform = "scale(1)";

                    const canvas = await html2canvas(storyRef?.current, {
                        useCORS: true,
                        allowTaint: true,
                        // scale: window.devicePixelRatio, // Capturar en alta resolución
                        scale: 2,
                        width: originalWidth,
                        height: originalHeight,
                    });
                    const dataUrl = canvas.toDataURL("image/png", 1.0);

                    const link = document.createElement("a");
                    link.href = dataUrl;

                    const name = confidencial
                        ? `Confidencial-${ubicacion}.png`
                        : `Story_${data?.nombre.replace(/ /g, "_")}_${data?.cuenta?.nombre.replace(/ /g, "_")}.png`

                    link.download = name;
                    link.click();

                    storyRef.current.style.transform = `scale(${scale / 100})`;
                }
            } else if (type === 'feed') {
                if (feedRef?.current) {
                    const originalWidth = feedRef.current.offsetWidth;
                    const originalHeight = feedRef.current.offsetHeight;

                    feedRef.current.style.transform = "scale(1)";

                    const canvas = await html2canvas(feedRef?.current, {
                        useCORS: true,
                        allowTaint: true,
                        // scale: window.devicePixelRatio, // Capturar en alta resolución
                        scale: 2,
                        width: originalWidth,
                        height: originalHeight,
                    });
                    const dataUrl = canvas.toDataURL("image/png", 1.0);

                    const link = document.createElement("a");
                    link.href = dataUrl;

                    const name = confidencial
                        ? `Confidencial-${ubicacion}.png`
                        : `Feed_${data?.nombre.replace(/ /g, "_")}_${data?.cuenta?.nombre.replace(/ /g, "_")}.png`

                    link.download = name;
                    link.click();

                    feedRef.current.style.transform = `scale(${scale / 100})`;
                }
            }
        } catch (error) {
            // console.error("Error al capturar el div:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchLogo = async () => {
        try {
            const response = await HttpGet(`account/${data?.cuenta_id}/logoBase64`, false)
            setImagen(response[0]?.$base64);
        } catch (error) {
            return error
        }
    };

    const normalizeImageBase64 = (value) => {
        if (!value) return "";
        if (String(value).startsWith("data:image")) return value;
        return `data:image/png;base64,${value}`;
    };

    const fetchNiveles = async (accountId) => {
        try {
            const response = await HttpGet(`account-public/${accountId}/levels`, false)
            const nivelActual = response?.find(n => n.slug == data?.nivel && n?.visible == true)
            setNivel(nivelActual);

            const logoBase64 =
                nivelActual?.logo_base64 ||
                nivelActual?.logoBase64 ||
                nivelActual?.base64 ||
                nivelActual?.$base64;

            setImagen3(normalizeImageBase64(logoBase64));
        } catch (error) {
            return error
        }
    }

    // console.log(data)

    useEffect(() => {
        if (data?.id > 0) {

            // console.log(data)

            if (data?.privada) {
                setInstitucion("Institución Confidencial");
                setImagen(imgConfidencial);
                setImagen2("");
            } else {
                fetchLogo()
                setInstitucion(data?.cuenta?.nombre);
                // loadImage();
                setImagen2(placeholder_image)
            }

            setUbicacion(data?.ubicacion?.localidad || 'Sin informar');
            setPuesto(data?.nombre);
            setRequisitos(data?.descripcion);
            setConfidencial(data?.privada);

            if (data?.cuenta?.user?.plan?.plan_id == 1) {
                //ES GOLD CONSULTO SI TIENE NIVELES
                fetchNiveles(data?.cuenta?.id)
            }
        }
    }, [data]);

    const handleImageChange = (event, setImage) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => setImage(e.target.result);
            reader.readAsDataURL(file);
        } else {
            // Cargar la imagen desde URL pública como base64
            fetch(`${PUBLIC_URI}uploads/${data?.cuenta?.logo_url}`)
                .then(response => response.blob())
                .then(blob => {
                    const reader = new FileReader();
                    reader.onload = (e) => setImage(e.target.result);
                    reader.readAsDataURL(blob);
                })
                .catch(err => {
                    // console.error('Error al cargar imagen:', err);
                });
        }
    };

    const handleRemoveImage = (setImage, inputRef) => {
        setImage(placeholder_image);
        if (inputRef && inputRef.current) {
            inputRef.current.value = null; // Restablecer el valor del input
        }
    };


    const checkHabilitar = (checked, pos = 1) => {

        pos == 1 ? setIsImage1Enabled(checked) : (pos == 2 ? setIsImage2Enabled(checked) : setIsImage3Enabled(checked));
        if (checked) {
            setDisplayImgs('none');
            setDisplayDoble('block')
        } else {
            setDisplayImgs('block');
            setDisplayDoble('none')
        }
    }

    useEffect(() => {
        if (quill) {
            quill.on('text-change', () => {
                setRequisitos(quill.root.innerHTML);
            });
        }
    }, [quill]);

    useEffect(() => {
        if (quill && requisitos && !hasSetContent) {
            quill.clipboard.dangerouslyPasteHTML(''); // Limpia el contenido actual
            quill.clipboard.dangerouslyPasteHTML(requisitos); // Establece el contenido inicial
            setHasSetContent(true); // Marca que ya se configuró el contenido
        }
    }, [quill, requisitos, hasSetContent]);

    useEffect(() => {
        if (quill) {
            quill.on('text-change', () => {
                setRequisitos(quill.root.innerHTML); // Actualiza el estado correctamente
            });
        }
    }, [quill]);

    const [modalWidth, setModalWidth] = useState('75%');


    /*
        max-sm:scale-[0.3]: 640px
        max-md:scale-[0.5]: 768px
        max-lg:scale-50: px
        lg:scale-[0.4]: px
        xl:scale-[0.6]: px
    */

    useEffect(() => {
        const updateModalWidth = () => {
            const width = window.innerWidth;

            if (width <= 640) { // Celular
                setScale(30);
                setColumn(true);
                setModalWidth('100%');
            }

            else if (width < 768) { // Tablet chica
                setScale(50);
                setColumn(false);
                setModalWidth('95%');
            }

            else if (width < 1024) { // Tablet grande
                setScale(50);
                setColumn(false);
                setModalWidth('85%');
            }

            else if (width < 1280) { // Laptop chica
                setScale(40);
                setColumn(true);
                setModalWidth('95%');
            }

            else if (width < 1440) { // Laptop grande
                setScale(50);
                setColumn(true);
                setModalWidth('95%');
            }

            else if (width < 1800) { // Computadora
                setScale(60);
                setColumn(false);
                setModalWidth('95%');
            }

            else if (width < 2000) { // Computadora grande
                setScale(60);
                setColumn(false);
                setModalWidth('85%');
            }

            else { // Computadora más grande
                setScale(60);
                setColumn(false);
                setModalWidth('75%');
            }
        };

        updateModalWidth(); // Ejecutar al cargar
        window.addEventListener('resize', updateModalWidth); // Escuchar cambios

        return () => window.removeEventListener('resize', updateModalWidth); // Limpiar
    }, []);

    const collapseItems = [
        {
            key: 1,
            align: 'left',
            className: 'bg-[#fff]',
            label: <label className='text-sm font-semibold mb-1'>Ajustes avanzados</label>,
            children:
                <>
                    <div>
                        <label className='text-sm font-semibold mb-1'>Tamaño título</label>
                        <Slider
                            min={20}
                            max={140}
                            value={titleSize}
                            onChange={setTitleSize}
                            className="mb-4"
                            style={{ width: '100%' }}
                        />
                    </div>

                    <div>
                        <label className='text-sm font-semibold mb-1'>Tamaño ubicación</label>
                        <Slider
                            min={20}
                            max={140}
                            value={locationSize}
                            onChange={setLocationSize}
                            className="mb-4"
                            style={{ width: '100%' }}
                        />
                    </div>

                    <div>
                        <label className='text-sm font-semibold mb-1'>Tamaño puesto</label>
                        <Slider
                            min={20}
                            max={140}
                            value={jobSize}
                            onChange={setJobSize}
                            className="mb-4"
                            style={{ width: '100%' }}
                        />
                    </div>

                    <>
                        {/* <label className='text-sm font-semibold mb-1'>Imagen 1</label> */}

                        {/* <section className="flex w-full">
                                <input
                                    ref={inputRef1}
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => { handleImageChange(e, setImagen) }}
                                    className="border w-[70%] rounded-md mb-4 px-2 py-1"
                                />

                                <Button label="Borrar Imagen 1" onClick={() => handleRemoveImage(setImagen, inputRef1)} className="mb-4 bg-red-500 text-white" />
                            </section> */}

                        <label className='text-sm font-semibold mb-1'>Tamaño de Logo</label>
                        <Slider
                            min={50}
                            max={500}
                            value={imgSize}
                            onChange={setImgSize}
                            className="mb-4"
                            style={{ width: '100%' }}
                        />

                        <div style={{ display: displayImgs }}>
                            <label className='text-sm font-semibold mb-1'>Eje Y Logo</label>
                            <Slider
                                min={1}
                                max={500}
                                value={ejeYImg1}
                                onChange={setEjeYImg1}
                                className="mb-4"
                                style={{ width: '100%' }}
                            />
                        </div>
                    </>

                    {!confidencial &&
                        <>
                            <Checkbox
                                checked={isImage1Enabled}
                                onChange={(e) => checkHabilitar(e.target.checked, 1)}
                                className="mb-4"
                            >
                                Habilitar logo
                            </Checkbox>

                            {data?.cuenta?.user?.plan?.plan_id == 1 &&
                                <Checkbox
                                    checked={isImage3Enabled}
                                    onChange={(e) => checkHabilitar(e.target.checked, 3)}
                                    className="mb-4"
                                >
                                    Habilitar logo nivel
                                </Checkbox>
                            }

                            <Checkbox
                                checked={isImage2Enabled}
                                onChange={(e) => checkHabilitar(e.target.checked, 2)}
                                className="mb-4"
                            >
                                Habilitar 2da imagen
                            </Checkbox>

                            {isImage2Enabled &&
                                <>
                                    <label className='text-sm font-semibold mb-1'>Imagen 2</label>

                                    <section className="flex w-full">
                                        <input
                                            ref={inputRef2}
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => { handleImageChange(e, setImagen2) }}
                                            className="border w-[70%] rounded-md mb-4 px-2 py-1"
                                        />

                                        <Button label="Borrar Imagen 2" onClick={() => handleRemoveImage(setImagen2, inputRef2)} className="mb-4 bg-red-500 text-white" />
                                    </section>

                                    <label className='text-sm font-semibold mb-1'>Tamaño de Imagen 2</label>
                                    <Slider
                                        min={50}
                                        max={500}
                                        value={imgSize2}
                                        onChange={setImgSize2}
                                        className="mb-4"
                                        style={{ width: '100%' }}
                                    />

                                    <div style={{ display: displayImgs }}>
                                        <label className='text-sm font-semibold mb-1'>Eje Y imagen 2</label>
                                        <Slider
                                            min={1}
                                            max={500}
                                            value={ejeYImg2}
                                            onChange={setEjeYImg2}
                                            className="mb-4"
                                            style={{ width: '100%' }}
                                        />
                                    </div>

                                </>
                            }
                            {moreThanOneImageactive() &&
                                <div>
                                    <label className='text-sm font-semibold mb-1'>Eje Y imágenes</label>
                                    <Slider
                                        min={1}
                                        max={500}
                                        value={ejeYImgDoble}
                                        onChange={setEjeYImgDoble}
                                        className="mb-4"
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            }
                        </>
                    }
                </>
        }
    ]

    return (
        <Modal
            open={isModalOpen}
            style={{ top: 15 }}
            onCancel={handleClose}
            width={modalWidth}
            footer={
                <div className="flex justify-end gap-2 w-full">
                    <AntButton
                        key="cancel"
                        onClick={handleClose}
                        size="large"
                        danger
                    >
                        Cancelar
                    </AntButton>

                    <Button
                        key="download"
                        type="primary"
                        label={isLoading ? "Procesando..." : "Descargar"}
                        onClick={handleDownload}
                        disabled={isLoading}
                        loading={isLoading}
                        size="large"
                        className="bg-[#00635d] hover:bg-[#005249] text-white font-medium transition-all duration-300"
                    />

                    <Button
                        key="attach"
                        type="primary"
                        label={isLoading ? "Subiendo..." : "Adjuntar a la publicación"}
                        onClick={handleAttachToPublication}
                        disabled={isLoading}
                        loading={isLoading}
                        size="large"
                        className="bg-[#fece00] hover:bg-[#bfa800] text-black font-medium transition-all duration-300"
                    />
                </div>
            }
        >
            <main className='flex flex-row max-lg:flex-col w-full pt-5 gap-5 min-[1540px]:w-[1440px] min-[1540px]:mx-auto'>

                {/* INPUTS */}
                <section className='w-1/3 max-lg:w-full p-4 bg-white rounded-lg shadow'>

                    {confidencial ?
                        <div className={`flex ${column ? "flex-col" : "flex-row gap-2"}`}>
                            <div className={`${column ? "w-full" : "w-1/2"}`}>
                                <label className='text-sm font-semibold mb-1'>Ubicación</label>
                                <input
                                    value={ubicacion}
                                    onChange={(e) => setUbicacion(e.target.value)}
                                    type="text"
                                    className="border w-full rounded-md mb-4 px-2 py-1 bg-white"
                                    maxLength={20}
                                />
                            </div>

                            <div>
                                <label className='text-sm font-semibold mb-1'>Puesto</label>
                                <input
                                    value={puesto}
                                    onChange={(e) => setPuesto(e.target.value)}
                                    type="text"
                                    className="border w-full rounded-md mb-4 px-2 py-1 bg-white"
                                    maxLength={100}
                                />
                            </div>
                        </div>
                        :
                        <div className={`flex ${column ? "flex-col" : "flex-row gap-2"}`}>
                            <div className={`${column ? "w-full" : "w-1/2"}`}>
                                <label className='text-sm font-semibold mb-1'>Institución</label>
                                <input
                                    value={institucion}
                                    onChange={(e) => setInstitucion(e.target.value)}
                                    type="text"
                                    className="border w-full rounded-md mb-4 px-2 py-1  bg-white"
                                    maxLength={50}
                                />
                            </div>

                            <div className={`${column ? "w-full" : "w-1/2"}`}>
                                <label className='text-sm font-semibold mb-1'>Ubicación</label>
                                <input
                                    value={ubicacion}
                                    onChange={(e) => setUbicacion(e.target.value)}
                                    type="text"
                                    className="border w-full rounded-md mb-4 px-2 py-1 bg-white"
                                    maxLength={20}
                                />
                            </div>
                        </div>
                    }

                    {!confidencial &&
                        <>
                            <label className='text-sm font-semibold mb-1'>Puesto</label>
                            <input
                                value={puesto}
                                onChange={(e) => setPuesto(e.target.value)}
                                type="text"
                                className="border w-full rounded-md mb-4 px-2 py-1 bg-white"
                                maxLength={100}
                            />
                        </>
                    }

                    <label className='text-sm font-semibold mb-1'>Requisitos</label>
                    <Editor classname="bg-white w-full h-36" quillRef={quillRef} />

                    <Collapse
                        size="middle"
                        className="w-full bg-gray-100 mt-16"
                        items={collapseItems}
                        bordered={false}
                    />
                </section>

                {/* POST */}
                {type === 'post' &&
                    <section className='w-2/3 max-lg:w-full max-sm:h-[400px] lg:h-[520px] max-md:h-[600px] max-lg:h-[600px] xl:h-[750px] bg-gray-50 rounded-lg flex flex-col items-center justify-start'>

                        {isLoading && <section className="w-full h-[500px] flex justify-center"><Loader /></section>}

                        <div className="overflow-hidden">
                            {!isLoading &&
                                <main
                                    ref={postRef}
                                    className={`post-card mt-3 bg-white relative`}
                                    style={{ width: '1080px', height: '1080px', transform: `scale(${scale / 100})`, transformOrigin: 'top' }}
                                >
                                    <section className='absolute w-full h-[130px] flex-col z-10' style={{ top: '30px', left: '0', right: '0', marginTop: '30px' }}>
                                        <p style={{ fontSize: titleSize }} className="font-bold text-black text-center font-encode">{institucion}</p> {/* Título */}
                                        <p style={{ fontSize: locationSize, lineHeight: '30px', marginTop: '5px' }} className="text-black text-center font-encode">[{ubicacion}]</p>
                                    </section>

                                    {/* {(!isImage2Enabled && isImage1Enabled) &&
                                        <section className='w-full flex justify-center items-center absolute' style={{ top: ejeYImg1, marginTop: '10px' }}>
                                            <img
                                                style={{ width: `${parseInt(imgSize) + 30}px` }}
                                                className="aspect-auto z-0"
                                                src={imagen}
                                                alt='Logo'
                                            />
                                        </section>
                                    } */}
                                    {(isImage2Enabled || isImage1Enabled || isImage3Enabled) &&
                                        <section className={`w-full flex justify-center items-center ${(moreThanOneImageactive()) && 'gap-[20px]'} absolute`} style={{ top: (moreThanOneImageactive()) ? ejeYImgDoble : ejeYImg1, marginTop: '10px' }}>
                                            {isImage1Enabled &&
                                                <img
                                                    style={{ width: `${parseInt(imgSize) + 30}px` }}
                                                    className="aspect-auto z-0"
                                                    src={imagen}
                                                    alt='Logo'
                                                />
                                            }

                                            {(isImage3Enabled && imagen3) &&
                                                <img
                                                    style={{ width: `${parseInt(imgSize) + 30}px` }}
                                                    className="aspect-auto z-0"
                                                    src={imagen3}
                                                    alt='Logo'
                                                />

                                            }

                                            {(isImage3Enabled && !imagen3) &&
                                                <LevelCircle slug={nivel?.slug} w={52} h={52} textClass='text-9xl w-[180px] h-[180px] mx-4 block' />
                                            }

                                            {isImage2Enabled &&
                                                <img
                                                    style={{ width: `${parseInt(imgSize2) + 30}px` }}
                                                    className="aspect-auto z-0"
                                                    src={imagen2}
                                                    alt='Logo'
                                                />
                                            }
                                        </section>
                                    }

                                    <section className='w-full absolute' style={{ top: '375px', left: '0', right: '0', marginTop: '25px' }}>
                                        <p style={{ fontSize: jobSize, lineHeight: '64px' }} className="font-bold text-center text-black font-encode">{puesto}</p>
                                    </section>

                                    <section className='w-[940px] h-[300px] absolute' style={{ top: '585px', left: '85px', marginTop: '25px' }}>
                                        <p className="quill-content text-base m-auto font-medium text-black font-encode" dangerouslySetInnerHTML={{ __html: requisitos }}></p>
                                    </section>
                                </main>
                            }
                        </div>
                    </section>
                }

                {/* STORY */}
                {type === 'story' &&
                    <section className='w-2/3 max-lg:w-full max-sm:h-[630px] max-md:h-[860px] max-lg:h-[725px] max-xl:h-[790px] xl:h-[745px] min-[1440px]:h-[745px] bg-gray-50 rounded-lg flex flex-col items-center justify-start'>

                        {isLoading && <section className="w-full h-[500px] flex justify-center"><Loader /></section>}

                        <div className="overflow-hidden">
                            {!isLoading &&
                                <main
                                    ref={storyRef}
                                    className={`story-card mt-3 bg-white relative max-sm:scale-[0.3] max-md:scale-[0.44] max-lg:scale-[0.37] lg:scale-[0.4] xl:scale-[0.38]`}
                                    style={{ width: '1080px', height: '1920px', transformOrigin: 'top' }}
                                >
                                    <section className='absolute w-full h-[130px] flex-col z-10' style={{ top: '152px', left: '0', right: '0', marginTop: '30px' }}>
                                        <p style={{ fontSize: titleSize }} className="font-bold text-black text-center font-encode mt-5">{institucion}</p>
                                        <p style={{ fontSize: locationSize, lineHeight: '30px' }} className="text-black text-center font-encode">[{ubicacion}]</p>
                                    </section>

                                    {(isImage2Enabled || isImage1Enabled || isImage3Enabled) &&
                                        <section className={`w-full flex justify-center items-center ${(moreThanOneImageactive()) && 'gap-[20px]'} absolute`} style={{ top: (moreThanOneImageactive()) ? ejeYImgDoble : ejeYImg1, marginTop: '10px' }}>
                                            {isImage1Enabled &&
                                                <img
                                                    style={{ width: `${parseInt(imgSize) + 30}px` }}
                                                    className="aspect-auto z-0"
                                                    src={imagen}
                                                    alt='Logo'
                                                />
                                            }

                                            {(isImage3Enabled && imagen3) &&
                                                <img
                                                    style={{ width: `${parseInt(imgSize) + 30}px` }}
                                                    className="aspect-auto z-0"
                                                    src={imagen3}
                                                    alt='Logo'
                                                />

                                            }

                                            {(isImage3Enabled && !imagen3) &&
                                                <LevelCircle slug={nivel?.slug} w={52} h={52} textClass='text-9xl w-[180px] h-[180px] mx-4 block' />
                                            }

                                            {isImage2Enabled &&
                                                <img
                                                    style={{ width: `${parseInt(imgSize2) + 30}px` }}
                                                    className="aspect-auto z-0"
                                                    src={imagen2}
                                                    alt='Logo'
                                                />
                                            }
                                        </section>
                                    }

                                    <section className='w-[940px] m-auto absolute' style={{ top: (isImage2Enabled || isImage1Enabled || isImage3Enabled) ? '680px' : '450px', left: '0', right: '0' }}>
                                        <p style={{ fontSize: jobSize, lineHeight: '68px' }} className="font-bold text-center text-black font-encode">{puesto}</p>
                                    </section>

                                    <section className='w-[940px] h-[300px] absolute' style={{ top: '880px', left: '85px', marginTop: '30px' }}>
                                        <p className="quill-content req-post text-base m-auto font-medium text-black font-encode" style={{ lineHeight: '32px !important' }} dangerouslySetInnerHTML={{ __html: requisitos }}></p>
                                    </section>
                                </main>
                            }
                        </div>
                    </section>
                }

                {/* FEED */}
                {type === 'feed' &&
                    <section className='w-2/3 max-lg:w-full max-sm:h-[455px] max-md:h-[720px] max-lg:h-[730px] max-xl:h-[595px] min-[1440px]:h-[865px] xl:h-[865px] bg-gray-50 p-5 rounded-lg flex flex-col items-center justify-start'>

                        {isLoading && <section className="w-full h-[500px] flex justify-center"><Loader /></section>}

                        <div className="overflow-hidden">
                            {!isLoading &&
                                <main
                                    ref={feedRef}
                                    className={`feed-card mt-3 bg-white relative`}
                                    style={{ width: '1080px', height: '1350px', transform: `scale(${scale / 100})`, transformOrigin: 'top' }}
                                >
                                    <section className='absolute w-full h-[130px] flex-col z-10' style={{ top: '44px', left: '0', right: '0', marginTop: '40px' }}>
                                        <p style={{ fontSize: titleSize }} className="font-bold text-black text-center font-encode">{institucion}</p> {/* Título */}
                                        <p style={{ fontSize: locationSize, lineHeight: '30px', marginTop: '5px' }} className="text-black text-center font-encode">[{ubicacion}]</p>
                                    </section>

                                    {(isImage2Enabled || isImage1Enabled || isImage3Enabled) &&
                                        <section className={`w-full flex justify-center items-center ${(moreThanOneImageactive()) && 'gap-[20px]'} absolute`} style={{ top: (moreThanOneImageactive()) ? ejeYImgDoble : ejeYImg1, marginTop: '10px' }}>
                                            {isImage1Enabled &&
                                                <img
                                                    style={{ width: `${parseInt(imgSize) + 30}px` }}
                                                    className="aspect-auto z-0"
                                                    src={imagen}
                                                    alt='Logo'
                                                />
                                            }

                                            {(isImage3Enabled && imagen3) &&
                                                <img
                                                    style={{ width: `${parseInt(imgSize) + 30}px` }}
                                                    className="aspect-auto z-0"
                                                    src={imagen3}
                                                    alt='Logo'
                                                />

                                            }

                                            {(isImage3Enabled && !imagen3) &&
                                                <LevelCircle slug={nivel?.slug} w={52} h={52} textClass='text-9xl w-[180px] h-[180px] mx-4 block' />
                                            }

                                            {isImage2Enabled &&
                                                <img
                                                    style={{ width: `${parseInt(imgSize2) + 30}px` }}
                                                    className="aspect-auto z-0"
                                                    src={imagen2}
                                                    alt='Logo'
                                                />
                                            }
                                        </section>
                                    }

                                    <section className='w-full absolute' style={{ top: (isImage2Enabled || isImage1Enabled || isImage3Enabled) ? '450px' : '210px', left: '0', right: '0', marginTop: '25px' }}>
                                        <p style={{ fontSize: jobSize, lineHeight: '64px' }} className=" font-bold text-center text-black font-encode">{puesto}</p>
                                    </section>

                                    <section className='w-[940px] h-[300px] absolute' style={{ top: (isImage2Enabled || isImage1Enabled || isImage3Enabled) ? '695px' : '695px', left: '85px', marginTop: '25px' }}>
                                        <p className="quill-content text-base m-auto font-medium text-black font-encode" dangerouslySetInnerHTML={{ __html: requisitos }}></p>
                                    </section>
                                </main>
                            }
                        </div>
                    </section>
                }
            </main>
        </Modal>
    );
}
